import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { TranslateService } from "@ngx-translate/core";
import { ExpenseSyncDataStatus } from "src/app/_models/enum/solo-enum";

@Component({
    selector: 'expense-export-status-renderer',
    templateUrl: './expense-export-status-renderer.component.html',
    standalone: false
})
export class ExpenseExportStatusRendererComponent implements ICellRendererAngularComp {
  text: string = '';
  class: string = '';
  reason: string = '';
  param: any;

  constructor(private translate: TranslateService) {
  }

  initilize(params: ICellRendererParams) {
    const statusId = params.getValue();
    this.reason = '';
    if (statusId == ExpenseSyncDataStatus.Success) {
      this.text = this.translate.instant('success');
      this.class = 'color-green font-weight-bold';
    } else if (statusId == ExpenseSyncDataStatus.Fail) {
      this.text = this.translate.instant('fail');
      this.class = 'color-red font-weight-bold';
      this.reason = params.data?.reason;
    } else if (statusId == ExpenseSyncDataStatus.InQueue) {
      this.text = this.translate.instant('in_queue');
      this.class = '';
    } else {
      this.text = '';
      this.class = '';
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
}
